import React from "react";
import { useSelector } from "react-redux";
import { selectors } from "rdx";

import { PrimaryButton } from "components/mui-styled-components";
import RightArrow2 from "components/Icons/Arrows/rightArrow2";

import { theme } from "styles/themes";
import * as S from "./styles";

const VisionSelfDesignDisplay = () => {
  const leadDetails = useSelector(selectors.selectLeadToProposalLeadDetails);
  const projectDetails = useSelector(selectors.selectLeadToProposalProjectDetails);

  const openVisionInNewTab = () => {
    const visionProposalUrl = `${process.env.REACT_APP_VISION_CLIENT_URL}/proposal/${projectDetails.visionProposal.slug}`;
    window.open(visionProposalUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <S.VisionRequestCompleteContainer>
      <S.VisionProposalCard>
        <S.VisionProposalCardHeader>Ready to build your proposal?</S.VisionProposalCardHeader>
        <S.VisionDescriptionContainer>
          <div>In Vision, you&apos;ll:</div>
          <S.VisionDescriptionRow>
            <RightArrow2 width="16" fill={theme.colors["dark-blue"]} /> Model energy usage
          </S.VisionDescriptionRow>
          <S.VisionDescriptionRow>
            <RightArrow2 width="18" fill={theme.colors["dark-blue"]} /> Finalize system design
          </S.VisionDescriptionRow>
          <S.VisionDescriptionRow>
            <RightArrow2 width="18" fill={theme.colors["dark-blue"]} /> Set up product and pricing
          </S.VisionDescriptionRow>
        </S.VisionDescriptionContainer>
        <PrimaryButton gradient onClick={openVisionInNewTab} width="100%" height="56px">
          <S.VisionButtonText>
            Continue to Vision <RightArrow2 width="22" fill={theme.colors.white} />
          </S.VisionButtonText>
        </PrimaryButton>
      </S.VisionProposalCard>
      <S.HomeownerDetailsContainer>
        <S.Divider />
        <S.DetailsRow>
          <S.HomeownerDetailsLabel>Homeowner</S.HomeownerDetailsLabel>
          <S.DetailsText>{leadDetails?.fullName}</S.DetailsText>
        </S.DetailsRow>
        <S.DetailsRow>
          <S.HomeownerDetailsLabel>Address</S.HomeownerDetailsLabel>
          <S.DetailsText>
            {leadDetails?.address?.street}, {leadDetails?.address?.city} {leadDetails?.address?.state}
          </S.DetailsText>
        </S.DetailsRow>
        <S.DetailsRow>
          <S.HomeownerDetailsLabel>Design</S.HomeownerDetailsLabel>
          <S.DetailsText>Self-Design</S.DetailsText>
        </S.DetailsRow>
        <S.Divider />
      </S.HomeownerDetailsContainer>
    </S.VisionRequestCompleteContainer>
  );
};

export default VisionSelfDesignDisplay;
